import { FC } from 'react';
import { Capacitor } from '@capacitor/core';
import { Typography } from '@mui/material';
import { HostCardAdvantagesList, HostCardQrCode } from 'components/shared';
import styles from '../index.module.scss';

interface CardBannerContentProps {
	qrCodeClassName?: string;
}

export const CardBannerContent: FC<CardBannerContentProps> = ({ qrCodeClassName = '' }) => {
	return (
		<>
			<Typography
				className={styles.title}
				variant="subtitle1"
				color="var(--color-primary-500)"
			>
				Миттєва цифрова картка - без візиту в банк:
			</Typography>
			<HostCardAdvantagesList />
			{!Capacitor.isNativePlatform() && <HostCardQrCode className={qrCodeClassName} />}
		</>
	);
};
